import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/shadcn/components/ui";
type Props = {
  COMPARISON_DATA: any;
};
const Comparison = ({ COMPARISON_DATA }: Props) => {
  return (
    <Table>
      <TableHeader className="bg-slate-200">
        <TableRow>
          <TableHead className="font-semibold">Parameter</TableHead>
          <TableHead className="font-semibold text-center">Before MYT</TableHead>
          <TableHead className="font-semibold text-center">After MYT</TableHead>
          <TableHead className="font-semibold text-center">% Change</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {COMPARISON_DATA.map((row: any, index: number) => (
          <TableRow key={index} className={index % 2 === 0 ? "bg-muted/50" : ""}>
            <TableCell className="font-medium">{row.parameter}</TableCell>
            <TableCell className="text-center">{row.beforeMYT}</TableCell>
            <TableCell className="text-center">{row.afterMYT}</TableCell>
            {/* <TableCell className="text-center text-red-600 font-medium">
                                            {row.change}
                                        </TableCell> */}
            <TableCell className="text-center text-red-600 font-medium">
              {row.change?.startsWith("-") ? (
                <span className="text-red-600">{row.change ? `${row.change}` : "-"} </span>
              ) : row.change?.startsWith("+") ? (
                <span className="text-green-600">{row.change ? `${row.change}` : "-"}</span>
              ) : (
                <span className="text-gray-600">{row.change ? `${row.change}` : "-"}</span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default Comparison;
